// extracted by mini-css-extract-plugin
export default {"container":"InfoContainer_container__ft+wQ","text":"InfoContainer_text__Ggizg","link":"InfoContainer_link__ck4C6"};